export const SW_MESSAGE_SKIP_WAITING = 'PROKA_SKIP_WAITING' as const
